namespace advisorop.components.advisor {

    export class AdvisorSalesforceConfigurationController {

        step: number;
        classStep: domains.SalesForceClassMapStep;
        user: domains.identity.IUser

        classMapping: boolean = false;

        // dropdowns

        advisoryFirms: Array<domains.IAdvisoryFirm> = [];
        selAdvisoryFirm: domains.IAdvisoryFirm = {};

        externalSystem: domains.IAdvisorExternalSystem;

        salesForceConfig: domains.externalsystem.IExternalSystemConfig = {};

        configurationLevel: any = domains.ConfigurationLevel;
        configurationType: any = domains.ConfigurationType;

        selConfigurationType: any = domains.ConfigurationType;

        salesforceObjects: Array<domains.externalsystem.ISalesforceObject> = [];
        selSalesforceObject: domains.externalsystem.ISalesforceObject = {};
        contactObjectFields: Array<domains.externalsystem.IObjectField> = [];
        householdObjectFields: Array<domains.externalsystem.IObjectField> = [];
        selContactObjectFields: domains.externalsystem.IObjectField = {};

        classMapp: Array<domains.externalsystem.IExternalSystemsClassMapping> = [];
        houseHoldClassMap: Array<domains.externalsystem.IExternalSystemsClassMapping> = [];
        investors: Array<domains.IInvestor> = [];

        selHouseholdFKey: domains.externalsystem.IObjectField = {};
        selHouseholdFKeyValue: string;

        selHouseholdPKey: domains.externalsystem.IObjectField = {};
        selHouseholdPKeyValue: string;

        householdFKeys: Array<domains.externalsystem.IObjectField> = [];
        householdPKeys: Array<domains.externalsystem.IObjectField> = [];

        salesforceObjectLink: domains.externalsystem.ISalesforceObjectLink = { id: 0 };

        public dg: DevExpress.ui.dxDataGridOptions;

        loading: boolean;
        linkLoading: boolean;
        canEdit: boolean;
        objectSelected: boolean = false;
        showClassMappings: boolean;

        pkSelected: boolean;
        fkSelected: boolean;

        creatingConfigLadda: boolean = false;
        updatingConfigLadda: boolean = false;


        loadOptions: DevExpress.ui.dxLoadPanelOptions = {
            shadingColor: "rgba(0,0,0,0.4)",
            position: { of: "#tabContent" },
            showIndicator: true,
            showPane: true,
            shading: false,
            closeOnOutsideClick: false,
            message: "Loading...",
            bindingOptions: {
                visible: "vm.loading"
            }
        };

        $router;
        static $inject = ["identityService", "advisorService", "advisoryFirmApi", "generalService"];
        constructor(private identityService: services.IdentityService,
            private advisorService: services.AdvisorService,
            private advisoryFirmApi: services.AdvisoryFirmApi,
            private generalService: services.GeneralService) {

            this.dg = {
                export: {
                    enabled: true,
                    fileName: "Investors"
                },
                bindingOptions: {
                    dataSource: "vm.investors"
                },
                paging: { pageSize: 20 },
                rowAlternationEnabled: true,
                showBorders: false,
                showColumnLines: false,
                columnAutoWidth: true,
                allowColumnReordering: false,
                allowColumnResizing: false,
                noDataText: "No Investors",
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: true },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: true,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    {
                        calculateCellValue: function (row) {
                            switch (row.investorType) {
                                case domains.IndividualType.ENTITY: {
                                    return "Entity";
                                }
                                case domains.IndividualType.INDIVIDUAL: {
                                    return "Individual";
                                }
                                default: {
                                    return "Unknow";
                                }
                            }
                        },
                        caption: "Type",
                        allowFiltering: true,
                        allowSorting: true,
                        allowSearch: true,
                        cssClass: "dxGridCol"
                    },
                    { dataField: "firstName", caption: "First name", cssClass: "dxGridCol" },
                    { dataField: "lastName", caption: "Last name", cssClass: "dxGridCol" },
                    { dataField: "entityName", caption: "Entity name", cssClass: "dxGridCol" },
                    { dataField: "fullAddress", caption: "Full address", cssClass: "dxGridCol" },
                    { dataField: "contactEmail", caption: "Email", cssClass: "dxGridCol" },
                    { dataField: "contactPhone", caption: "Phone", cssClass: "dxGridCol" }
                ]
            };
        }


        $onChanges(evt): void {
        }

        $onInit(): void {

            this.step = 0;
            this.classStep = 1;
        }

        goToStep(step: domains.SalesForceWizardStep) {

            if (step == domains.SalesForceWizardStep.GLOBAL_AF_API) {

                this.step = step;
                this.loading = !this.loading;
                this.getUser();
            }

            if (step == domains.SalesForceWizardStep.GLOBAL_AF_CLASS_MAPP) {
                this.classMapp = [];
                this.contactObjectFields = [];
                this.selSalesforceObject = {};

                this.classStep = domains.SalesForceClassMapStep.INVESTOR;

                if (this.salesForceConfig.id !== 0) {
                    this.step = step;

                    this.getSalesforceObjectFields(this.salesForceConfig, domains.SalesforceObject.account);

                } else {
                    toastr.warning("You need to set up salesforce global configuration first!");
                }
            }

            if (step == domains.SalesForceWizardStep.GLOBAL_AF_TEST) {
                this.objectSelected = false;
                this.selSalesforceObject = {};

                if (this.classMapp.filter(x => x.id === 0).length === 0) {
                    this.step = step;

                    this.getSalesforceObjectFields(this.salesForceConfig, domains.SalesforceObject.account);

                } else {
                    toastr.warning("You need to set up class map configuration first!");
                }
            }

        }

        goToClassMapStep(step: number) {
            if (step == domains.SalesForceClassMapStep.INVESTOR) {

                this.classMapp = [];
                this.contactObjectFields = [];
                this.selSalesforceObject = {};

                this.classStep = step;

                this.getSalesforceObjectFields(this.salesForceConfig, domains.SalesforceObject.account);

            } else if (step == domains.SalesForceClassMapStep.HOUSEHOLD) {

                this.classMapp = [];
                this.householdObjectFields = [];
                this.selSalesforceObject = {};
                this.selHouseholdFKey = {};
                this.selHouseholdFKeyValue = "";
                this.selHouseholdPKey = {};
                this.selHouseholdPKeyValue = "";

                this.classStep = step;

                this.getAllSalesforceObjects(this.salesForceConfig);
            }
        }

        getAllSalesforceObjects(salesForceConfig: domains.externalsystem.IExternalSystemConfig) {

            this.loading = !this.loading;
            this.advisorService.getAllSalesforceObjects(salesForceConfig)
                .then((data) => {
                    this.salesforceObjects = data.data["sobjects"];
                    //console.log("sobjects", this.salesforceObjects);
                    this.loading = !this.loading;

                    this.getObjectLink(this.salesForceConfig.companyGroupId, domains.AdvisorObject.household);

                })
                .catch((reason) => {
                    toastr.error(reason.data);
                    this.loading = !this.loading;
                });

        }

        getSalesforceObjectFields(salesForceConfig: domains.externalsystem.IExternalSystemConfig, salesforceObject: domains.SalesforceObject) {
            this.loading = !this.loading;
            this.advisorService.getSalesforceObjectFields(salesForceConfig, salesforceObject)
                .then((data) => {
                    if (data.data) {
                        this.contactObjectFields = data.data;
                        this.householdFKeys = data.data;
                        //console.log(`$_Contact_Fields`, this.contactObjectFields);
                        //this.householdFKeys = this.contactObjectFields;
                        this.getSalesforceClassMap(salesForceConfig, salesforceObject, domains.AdvisorObject.investor);
                        this.householdObjectFields = data.data;
                        this.householdPKeys = data.data;
                        //console.log(`$_Household_P_Keys`, this.householdPKeys);
                        this.loading = !this.loading;
                        /*
                                      if (this.salesforceObjectLink.id != 0) {
                                        this.selHouseholdPKey = this.householdPKeys.filter(x => x.name === this.salesforceObjectLink.salesforceObjectKey)[0];
                                        this.pkSelected = true;
                                        this.householdPKeyObjectChanged();
                                        this.selHouseholdFKey = this.householdFKeys.filter(x => x.name === this.salesforceObjectLink.salesforceLinkedObjectKey)[0];
                                        this.fkSelected = true;
                                        this.householdFKeyObjectChanged();
                                        this.loading = !this.loading;
                                      }
                        */
                    }
                })
                .catch((reason) => {
                    toastr.error(reason.data);
                    this.loading = !this.loading;
                });

        }

        getSalesforceClassMap(salesForceConfig: domains.externalsystem.IExternalSystemConfig, salesforceObject: domains.SalesforceObject, advisorObject: domains.AdvisorObject) {
            this.loading = true;
            this.advisorService.getSalesforceClassMap(salesForceConfig, salesforceObject, advisorObject)
                .then((data) => {
                    if (data.data) {
                        this.classMapp = data.data;

                        //console.log(`$_ClassMap`, this.classMapp);
                        if (this.classMapp[0].id === 0) toastr.warning("These are automatic settings and they may not be correct!");

                        if (salesforceObject === domains.SalesforceObject.contact) {
                            this.classMapp.forEach(c => {
                                if (c.externalSystemFieldName !== null) c.externalSystemDispalyName = this.contactObjectFields.filter(x => x.name === c.externalSystemFieldName)[0].label;
                            });
                        } else if (salesforceObject === domains.SalesforceObject.account) {
                            this.classMapp.forEach(c => {
                                if (c.externalSystemFieldName !== null) c.externalSystemDispalyName = this.householdObjectFields.filter(x => x.name === c.externalSystemFieldName)[0].label;
                            });
                        }

                        this.loading = !this.loading;
                    }
                })
                .catch((reason) => {
                    toastr.error(reason.data);
                    this.loading = !this.loading;
                });

        }

        setConfigurationType(type: domains.ConfigurationType) {
            this.selConfigurationType = type;
            if (type === domains.ConfigurationType.COMPANY_GROUP) {
                this.goToStep(1);
            } else if (type === domains.ConfigurationType.ADVISOR) {
                this.step = 24;
            }
        }

        setConfigurationLevel(level: domains.ConfigurationLevel) {
            this.salesForceConfig.configurationLevel = level;
            if (level === domains.ConfigurationLevel.NEW) {
                this.step = 1;
            } else if (level === domains.ConfigurationLevel.EXISTING) {
                this.step = 2;
            }
        }

        salesforceObjectChanged() {
            this.objectSelected = true;
            //console.log("salesforceObjectChanged", this.selSalesforceObject);
            //console.log("%%%", this.classMapp.length);
            if (this.selSalesforceObject.name.toLowerCase() in domains.SalesforceObject) {
                //console.log("enum", domains.SalesforceObject[this.selSalesforceObject.name.toLowerCase()]);
                this.getSalesforceObjectFields(this.salesForceConfig, domains.SalesforceObject[this.selSalesforceObject.name.toLowerCase()]);

            }
        }

        householdPKeyObjectChanged() {
            this.pkSelected = true;
            this.testSalesforceImportAllHouseholds(this.salesForceConfig, true);

            //this.getSalesforceObjectFields(this.salesForceConfig, domains.SalesforceObject.contact);
        }

        createOrSaveObjectLink() {

            this.loading = !this.loading;
            this.linkLoading = !this.linkLoading;

            this.salesforceObjectLink.advisorObject = domains.AdvisorObject.household;
            this.salesforceObjectLink.companyGroupId = this.salesForceConfig.companyGroupId;

            this.salesforceObjectLink.salesforceObject = this.selSalesforceObject.name;
            this.salesforceObjectLink.salesforceObjectKey = this.selHouseholdPKey.name;

            this.salesforceObjectLink.salesforceLinkedObject = "Contact";
            this.salesforceObjectLink.salesforceLinkedObjectKey = this.selHouseholdFKey.name;

            this.salesforceObjectLink.isGlobalConfiguration = true;
            this.salesforceObjectLink.isCostumObject = false;

            //console.log("salesforceObjectLink", this.salesforceObjectLink);

            this.advisorService.createOrSaveObjectLink(this.salesforceObjectLink)
                .then((data) => {
                    this.salesforceObjectLink = data.data;
                    toastr.success("Salesforce object link successfully changed.");
                    //console.log("$_salesforceObjectLink:", this.salesforceObjectLink);
                })
                .catch((reason) => {
                    toastr.error(reason.data);
                    this.loading = !this.loading;
                    this.linkLoading = !this.linkLoading;
                }).finally(() => {
                    this.loading = !this.loading;
                    this.linkLoading = !this.linkLoading;
                });

        }

        getObjectLink(companyGroupId: number, advisorObject: domains.AdvisorObject) {
            this.loading = !this.loading;
            this.advisorService.getObjectLink(companyGroupId, advisorObject)
                .then((data) => {
                    this.salesforceObjectLink = data.data;
                    if (this.salesforceObjectLink.id != 0) {
                        this.fillObjectLinkForm(this.salesforceObjectLink);
                    }
                    //console.log("ObjectLink", this.salesforceObjectLink);
                })
                .catch((reason) => {
                    toastr.error(reason.data);
                    this.loading = !this.loading;
                }).finally(() => {
                    this.loading = !this.loading;
                });
        }

        fillObjectLinkForm(salesforceObjectLink: domains.externalsystem.ISalesforceObjectLink) {
            this.objectSelected = true;
            this.selSalesforceObject = this.salesforceObjects.filter(x => x.name === salesforceObjectLink.salesforceObject)[0];
            this.salesforceObjectChanged();
        }

        householdFKeyObjectChanged() {
            this.fkSelected = true;
            this.testSalesforceImportAllContacts(this.salesForceConfig, true);

            this.getSalesforceClassMap(this.salesForceConfig, domains.SalesforceObject.account, domains.AdvisorObject.household);
        }

        getSystemConfiguration(externalSystemId: number, configurationType: domains.ConfigurationType) {

            this.advisorService.getSystemConfiguration(externalSystemId, configurationType)
                .then((data) => {
                    if (data.data) {
                        this.salesForceConfig = data.data;
                        //if (this.salesForceConfig.advisoryFirmId !== null) this.selAdvisoryFirm = this.advisoryFirms.filter(x => x.id === this.salesForceConfig.advisoryFirmId)[0];
                        //console.log(`$_Current ${domains.ConfigurationType[configurationType]} configuration`, this.salesForceConfig);
                        this.loading = !this.loading;
                    }
                })
                .catch((reason) => {
                    toastr.error(reason.data);
                    this.loading = !this.loading;
                });
        }

        changeSystemConfiguration(config: domains.externalsystem.IExternalSystemConfig) {

            this.salesForceConfig.externalSystemId = domains.ExternalSystem.SALESFORCE;

            //console.log("$_Configuration_for_CRUD:", config)

            config.configurationType = this.selConfigurationType;
            config.configurationLevel = config.id === 0 ? domains.ConfigurationLevel.NEW : domains.ConfigurationLevel.EXISTING;
            config.advisorId = config.id === 0 ? this.user.advisor.id : config.advisorId;
            config.companyGroupId = this.user.advisor.companyGroup.id;
            config.advisoryFirmId = (typeof this.user.advisor.advisoryFirms !== "undefined" && this.user.advisor.advisoryFirms !== null) ? this.user.advisor.advisoryFirms[0].id : 0;
            config.isGlobalConfiguration = true;
            if (this.selConfigurationType === domains.ConfigurationType.ADVISORY_FIRM) config.isGlobalConfiguration = true;

            if (config.id === 0) {
                this.creatingConfigLadda = true;

                this.advisorService.createGlobalSalesforceConfiguration(config)
                    .then((data) => {
                        this.salesForceConfig = data.data;
                        toastr.success("Salesforce configuration successfully created.");
                        //console.log("$_Configuration_after_create:", this.salesForceConfig);
                    })
                    .catch((reason) => {
                        toastr.error(reason.data);
                    }).finally(() => {
                        this.creatingConfigLadda = false;
                    });
            } else {
                this.updatingConfigLadda = true;

                this.advisorService.changeSystemConfiguration(config)
                    .then((data) => {
                        this.salesForceConfig = data.data;
                        toastr.success("Salesforce configuration successfully updated.");
                        //console.log("$_Configuration_after_update:", this.salesForceConfig);
                    })
                    .catch((reason) => {
                        toastr.error(reason.data);
                    }).finally(() => {
                        this.updatingConfigLadda = false;
                    });
            }
        }

        loadAdvisoryFirms(): void {
            this.advisoryFirmApi.getAdvisoryFirms()
                .then((data) => {
                    this.advisoryFirms = data.data;
                    this.getSystemConfiguration(domains.ExternalSystem.SALESFORCE, this.selConfigurationType);

                    if ((this.salesForceConfig.id != 0 && this.salesForceConfig.advisorId == this.user.advisor.id) || !!this.salesForceConfig) {
                        this.canEdit = true;
                    }
                })
                .catch((reason) => {
                    console.log("Error during load Advisory Firms");
                    console.log(reason);
                    this.loading = !this.loading;
                });
        };

        getAction() {
            return this.salesForceConfig.id === 0 ? "Create" : "Change";
        }

        advisoryFirmChanged() {
            if (this.selAdvisoryFirm !== null && typeof this.selAdvisoryFirm !== "undefined") {
                this.salesForceConfig.advisoryFirmId = this.selAdvisoryFirm.id;
            }
        }

        loadExternalSystem(id: domains.ExternalSystem): void {
            this.advisorService.getExternalSystem(id)
                .then((data) => {
                    this.salesForceConfig = data.data;
                    //console.log("$_Salesforce:", this.externalSystem);

                    // this.getSystemConfiguration(this.externalSystem.id);
                })
                .catch((reason) => {
                    console.log("Error during load externalSystems");
                    console.log(reason);
                });
        }

        getUser() {
            this.identityService.getUserPromise().then(response => {
                this.user = response;
                //console.log("$_USER", this.user);
                //this.loadAdvisoryFirms();
                this.getSystemConfiguration(domains.ExternalSystem.SALESFORCE, this.selConfigurationType);
            });
        }

        isPreviousVisible() {
            return (this.step === undefined || this.step === domains.SalesForceWizardStep.GLOBAL_AF_API) ? false : true;
        }

        isNextVisible() {
            return (this.step !== undefined && this.step !== domains.SalesForceWizardStep.GLOBAL_AF_TEST) ? true : false;
        }

        getStepClass(step: number) {
            return (this.step === step) ? "active" : (this.step > step) ? "disabled completed" : "disabled";
        }

        ContactFieldChanged(name: string, index: number) {
            this.classMapp[index].externalSystemFieldType = this.contactObjectFields.filter(x => x.name === name)[0].type;
            this.classMapp[index].externalSystemDispalyName = this.contactObjectFields.filter(x => x.name === name)[0].label;
        }

        HouseholdFieldChanged(name: string, index: number) {
            this.classMapp[index].externalSystemFieldType = this.householdObjectFields.filter(x => x.name === name)[0].type;
            this.classMapp[index].externalSystemDispalyName = this.householdObjectFields.filter(x => x.name === name)[0].label;
        }

        createOrSaveClassMapp(cm: Array<domains.externalsystem.IExternalSystemsClassMapping>) {

            this.classMapping = !this.classMapping;

            cm.forEach(x => {
                x.externalSystemConfigurationId = this.salesForceConfig.id;
                x.externalSystemCostumObject = (typeof this.selSalesforceObject !== "undefined" && this.selSalesforceObject !== null && cm[0].externalSystemObject === domains.SalesforceObject.costum) ? this.selSalesforceObject.name : null;
            });

            this.advisorService.createOrSaveClassMapp(cm)
                .then((data) => {
                    this.classMapp = data.data;
                    this.classMapping = !this.classMapping;
                    toastr.success("Class map settings successfully saved!")
                })
                .catch((reason) => {
                    console.log("Error during load Class Mapp");
                    console.log(reason);
                    this.classMapping = !this.classMapping;
                });
        }

        testSalesforceImportAllContacts(salesForceConfig: domains.externalsystem.IExternalSystemConfig, sourceData: boolean = false) {
            this.advisorService.testSalesforceImportAllContacts(salesForceConfig, sourceData)
                .then((data) => {
                    if (!sourceData) {
                        this.investors = data.data;
                        if (!sourceData) toastr.success("Contact were successfully imported from Salesforce and mapped to Investor class!");
                    }
                    if (sourceData) {

                        let desc = this.selHouseholdFKey.name;

                        let contacts = data.data as Array<any>;
                        let match = contacts.filter(x => x[desc] === this.selHouseholdPKeyValue)[0];

                        if (typeof match != "undefined" && match !== null) {
                            this.selHouseholdFKeyValue = match[this.selHouseholdFKey.name];

                            this.showClassMappings = true;

                        } else {
                            this.selHouseholdFKeyValue = `There's no match between keys`;
                        }

                    }

                })
                .catch((reason) => {
                    console.log("Error during contacts import");
                    console.log(reason);
                    toastr.error(reason.data);
                });

        }

        checkMatch() {
            if (this.selHouseholdFKeyValue === this.selHouseholdPKeyValue && this.selHouseholdPKeyValue !== "") {
                //this.getSalesforceObjectFields(this.salesForceConfig, domains.SalesforceObject[this.selSalesforceObject.name.toLowerCase()]);
                return "k-match";
            } else {
                return "k-no-match";
            }
        }

        testSalesforceImportAllHouseholds(salesForceConfig: domains.externalsystem.IExternalSystemConfig, sourceData: boolean = false) {
            this.loading = !this.loading;
            this.advisorService.testSalesforceImportAllHouseholds(salesForceConfig, sourceData)
                .then((data) => {
                    //this.investors = data.data;
                    //console.log("$_households", data.data);
                    if (!sourceData) toastr.success("Households were successfully imported from Salesforce and mapped to Household class!");
                    let desc = this.selHouseholdPKey.name;
                    this.selHouseholdPKeyValue = data.data[1][desc];
                    this.loading = !this.loading;
                })
                .catch((reason) => {
                    console.log("Error during households import");
                    console.log(reason);
                    toastr.error(reason.data);
                    this.loading = !this.loading;
                });

        }

        testSalesforceAdminConfig(salesForceConfig: domains.externalsystem.IExternalSystemConfig) {

            salesForceConfig.advisorId = this.user.advisor.id;
            if (salesForceConfig.id === null || typeof this.salesForceConfig.id === "undefined") this.salesForceConfig.id = 0;


            // TEST 

            salesForceConfig.consumerKey = "3MVG9I5UQ_0k_hTl1Kfr8DkBGCCqSGzaBD8SUy1hpXGJH4XR1Z1ba8PiU_XcDIwaQMj_C49v6vJtezBsrrYak";
            salesForceConfig.consumerSecret = "1415274651812342956";
            salesForceConfig.username = "filandra.irem@gmail.com";
            salesForceConfig.password = "w39Q8#JsgAT%PE*L5";
            salesForceConfig.securityToken = "vdIiMBXOcFvmkhd2O9i7um2zT";


            this.advisorService.testSalesforceAdminConfig(salesForceConfig)
                .then((data) => {

                })
                .catch((reason) => {
                    console.log("Error during load Advisory Firms");
                    console.log(reason);
                });
        }

        showPassword() {
            var element = angular.element(document.querySelector('#sfPassword'));
            var eye = angular.element(document.querySelector('#sfPasswordV'));

            if (element.attr("type") === "password") {
                element.attr("type", "text");
                eye.removeClass("glyphicon glyphicon-eye-open");
                eye.addClass("glyphicon glyphicon-eye-close");
            } else {
                element.attr("type", "password");
                eye.removeClass("glyphicon glyphicon-eye-close");
                eye.addClass("glyphicon glyphicon-eye-open");
            }
        }

        showConsumerKey() {
            var element = angular.element(document.querySelector('#sfConsumerKey'));
            var eye = angular.element(document.querySelector('#sfConsumerKeyV'));

            if (element.attr("type") === "password") {
                element.attr("type", "text");
                eye.removeClass("glyphicon glyphicon-eye-open");
                eye.addClass("glyphicon glyphicon-eye-close");
            } else {
                element.attr("type", "password");
                eye.removeClass("glyphicon glyphicon-eye-close");
                eye.addClass("glyphicon glyphicon-eye-open");
            }
        }

        showConsumerSecret() {
            var element = angular.element(document.querySelector('#sfConsumerSecret'));
            var eye = angular.element(document.querySelector('#sfConsumerSecretV'));

            if (element.attr("type") === "password") {
                element.attr("type", "text");
                eye.removeClass("glyphicon glyphicon-eye-open");
                eye.addClass("glyphicon glyphicon-eye-close");
            } else {
                element.attr("type", "password");
                eye.removeClass("glyphicon glyphicon-eye-close");
                eye.addClass("glyphicon glyphicon-eye-open");
            }
        }

        showSecurityToken() {
            var element = angular.element(document.querySelector('#sfSecurityToken'));
            var eye = angular.element(document.querySelector('#sfSecurityTokenV'));

            if (element.attr("type") === "password") {
                element.attr("type", "text");
                eye.removeClass("glyphicon glyphicon-eye-open");
                eye.addClass("glyphicon glyphicon-eye-close");
            } else {
                element.attr("type", "password");
                eye.removeClass("glyphicon glyphicon-eye-close");
                eye.addClass("glyphicon glyphicon-eye-open");
            }
        }

        getFieldStatus(fl: domains.externalsystem.IExternalSystemsClassMapping): string {
            if (fl.advisorFielRequired) return "reddot";
            return "";
        }

        $routerOnActivate(next, previous) {

        }
    }

    class AdvisorSalesforceConfiguration implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;
        public $routeConfig: any;

        constructor() {
            this.bindings = {
                $router: "<",
            };
            this.controller = AdvisorSalesforceConfigurationController;
            this.controllerAs = "vm";
            this.templateUrl = 'spa/advisor-module/components/advisor-salesforce-configuration.html';
        }
    }
    angular.module(Constants.APP).component("advisorSalesforceConfiguration", new AdvisorSalesforceConfiguration());
}
